import React from 'react';
import { number, string } from 'prop-types';
import cx from 'classnames';
import { scaleThreshold } from 'd3-scale';

import Icon from 'icons/battery.sprite.inline.svg';
import styles from './battery-icon.scss';

const ICON_COUNT = 7;
const ICON_WIDTH = 32;
const ICON_HEIGHT = 18;
const ICON_GRID_HEIGHT = 18;

const batteryLevels = [...Array(ICON_COUNT).keys()];

function convertVoltageToBatteryLevel(voltage) {
  /*
    The batteryVoltage has a range between ~11.5V and ~14.4V.
    The batteries shut off automatically at 11.5V to avoid wear.
    [min, avg, max]
    [11.5, 12.7, 14.4]
  */
  const batteryLevelScale = scaleThreshold()
    .domain([11.5, 11.7, 12.2, 12.7, 13.7, 14.4])
    .range(batteryLevels);

  return batteryLevelScale(voltage);
}

export default function BatteryIcon({ batteryVoltage, className }) {
  const level = convertVoltageToBatteryLevel(batteryVoltage);
  const yOffset = (ICON_COUNT - level - 1) * ICON_GRID_HEIGHT;
  const viewBox = `0 ${yOffset} ${ICON_WIDTH} ${ICON_HEIGHT}`;

  return (
    <Icon viewBox={viewBox} className={cx(styles.main, styles[`level-${level}`], className)} />
  );
}

BatteryIcon.propTypes = {
  className: string,
  batteryVoltage: number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/BatteryIcon/index.js